<template>
    <v-layout class="file-select">
        <v-chip
            class="mr-2"
            label
            small
            @click="selectFiles"
        >
            <v-icon v-if="counter > 0">mdi-clipboard-check-outline</v-icon>
            <v-icon v-else style="color: red">mdi-clipboard-alert-outline</v-icon>
            <span v-if="counter > 0">{{ counter }}</span>
            <v-btn v-if="counter > 0" x-small icon @click.stop="clear"><v-icon>clear</v-icon></v-btn>
        </v-chip>
        <input ref="fileinput" type="file" multiple @change="handleFileChange"/>
    </v-layout>
</template>

<script>

  export default {
    props: {
      required: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        counter: 0
      };
    },
    methods: {
      handleFileChange(e) {
        const files = Array.from(e.target.files);
        this.counter = files.length;
        this.$emit('change', files);
      },
      selectFiles() {
        this.$refs.fileinput.click();
      },
      clear() {
        this.counter = 0;
        handleFileChange({target: {files: []}});
      }
    }
  };
</script>

<style scoped>
  .file-select > input[type="file"] {
    display: none;
  }
</style>